import logo from "@assets/images/logo.svg"
import logoWhite from "@assets/images/logoWhite.svg"
import user from "@assets/images/user.svg"
import favs from "@assets/images/favs.svg"
import bag from "@assets/images/bag.svg"
import menu from "@assets/images/menu.svg"
import close from "@assets/images/close.svg"

const Icons = {
  logo,
  logoWhite,
  user,
  favs,
  bag,
  menu,
  close
}

export default Icons
